import React, { useState, useEffect } from 'react';
import { Constants } from '../../Constants';
import { mapsApi } from '../../utils/mapsApi';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/// provide values, onUpdateDeliveryAddress and bingApiKey to props
const DestinationLocationCard = (props) => {
	const [earliestDeliveryDateSpecifiedByUser, updateWhetherEarliestDeliveryDateIsSpecifiedByUser] = useState(false);
	const [latestDeliveryDateRequired, updateWhetherLatestDeliveryDateRequired] = useState(true);

	const [earliestDeliveryDate, updateEarliestDeliveryDate] = useState(null);
	const [latestDeliveryDate, updateLatestDeliveryDate] = useState(new Date());
	const [zipCodeSearched, updateZipCodeSearched] = useState(false);

	const destinationColor = "#1266f1";

	const getLocationByZipCode = (evt) => {
		// Update address elements here
		var api = new mapsApi();
		api.getAutoSuggestValues(evt.target.value + ",United States",props.bingApiKey)
			.then(returnVal => {
				if(returnVal.locality == null){
					returnVal.locality = "";
				}
				// alert(returnVal.adminDistrict);
				if(returnVal.adminDistrict == null){
					returnVal.adminDistrict = Constants.StatesList[0];
				}
				if(returnVal.postalCode == null){
					returnVal.postalCode = "";
				}
				document.getElementById("destination_locality").value = returnVal.locality;
				document.getElementById("destination_administrative_area_level_1").value = returnVal.adminDistrict;
				document.getElementById("destination_postal_code").value = returnVal.postalCode;

				props.onUpdateDeliveryAddress("freightPostingInputModel.deliveryCity",returnVal.locality);
				props.onUpdateDeliveryAddress("freightPostingInputModel.deliveryState",returnVal.adminDistrict);
				props.onUpdateDeliveryAddress("freightPostingInputModel.deliveryPostalcode",returnVal.postalCode);
			});
			updateZipCodeSearched(true);
	}

	useEffect(() => {
		updateEarliestDeliveryDate(new Date());
	},
	[earliestDeliveryDateSpecifiedByUser])

	return (
		<div className="col-sm-12 col-md-6 mt-3">
			<div className="card p-2 border border-muted">
			<h3><i className="fa fa-dot-circle-o mx-1" style={{"color": destinationColor}}></i>Destination</h3>
				{/* https://developers.google.com/maps/documentation/javascript/places-autocomplete */}
				<div className="row">
					{props.postingType != Constants.postingType.quickPosting.value
						&&
						<div className="col-12">
							<div className="row">
								<div className="form-group col-sm-12 col-md-6">
									<label className="control-label">Name of location or contact person</label>
									<input name="freightPostingInputModel.deliveryContactFullName" className="form-control" />
								</div>
								<div className="form-group col-sm-12 col-md-6">
									<label className="control-label">Location/person's contact number</label>
									<input name="freightPostingInputModel.deliveryContactPhoneNumber" className="form-control" />
								</div>
								<div className="col-12">
									<hr />
								</div>
							</div>
						</div>
					}
					<div className="form-group col-sm-12 col-md-6">                                                    
						<label>Enter address ZIP Code: </label>
						<div class="input-group">
							<input id="destination_autocomplete" className="form-control" type="text" 
								onBlur={(evt) => getLocationByZipCode(evt)}/>
							{/* NOTE: This button actually does nothing, but if you click it/focus it, you will trigger the blur event on the above input */}
							<div class="input-group-append">
								<input type="button" className="btn btn-success" value="Search"/>
							</div>
						</div>
					</div>
					{/* Here is where will add the control to additionally display the items. i.e. zipCodeSearched || InstructedToDisplayAll*/}
					{(zipCodeSearched || props.expandAddress) &&
						<div className="col-12">
							<div className="row">
								{props.postingType != Constants.postingType.quickPosting.value
									&&
									<div className="form-group col-sm-12">
										<label className="control-label" htmlFor="destination_street_number">Street Address</label>
										<input id="destination_street_number" name="freightPostingInputModel.deliveryAddress" 
											required className="form-control" />
									</div>
								}
								<div className="form-group col-sm-6 col-md-4">
									<label className="control-label">City</label>
									<input id="destination_locality" name="freightPostingInputModel.deliveryCity" className="form-control" 
										onChange={(evt) => props.onUpdateDeliveryAddress(evt.target.name,evt.target.value)} className="form-control" />
								</div>
								<div className="form-group col-sm-6 col-md-4">
									<label className="control-label">State</label>
									<select id="destination_administrative_area_level_1" name="freightPostingInputModel.deliveryState" className="form-select"
										onChange={(evt) => props.onUpdateDeliveryAddress(evt.target.name,evt.target.value)}>
										{Constants.StatesList.map((value,index) =>
											<option key={index} value={value}>{value}</option>
										)}
									</select>
								</div>
								<div className="form-group col-sm-6 col-md-4">
									<label className="control-label">Zip code</label>
									<input id="destination_postal_code" name="freightPostingInputModel.deliveryPostalCode" className="form-control" 
										onChange={(evt) => props.onUpdateDeliveryAddress(evt.target.name,evt.target.value)} className="form-control" />
								</div>
								<div className="form-group col-sm-6 col-md-4">
									<label className="control-label">Country</label>
									<input id="destination_country" disabled aria-disabled value="United States" className="form-control" />
									<input hidden name="freightPostingInputModel.deliveryCountry" value="United States"/>
								</div>
								{props.postingType != Constants.postingType.quickPosting.value
									&&
									<div className="form-group col-12">
										<label className="control-label">Delivery instructions</label>
										<input name="freightPostingInputModel.deliveryInstructions" className="form-control" />
									</div>
								}
							</div>
						</div>
					}
				</div>
			</div>
			
			<div className="card border border-muted p-2 mt-2">
				<h3><i className="fa fa-calendar mx-1" style={{"color": destinationColor}}></i>Delivery date</h3>
				<div className="row">
					<div className="col-12 my-2">
						<em>Specify earliest delivery time?</em><br />
						<div className="form-check form-check-inline ml-2 my-1">
							<input type="radio" className="form-check-input"
								id="Destination-Earliest-Time-Required"
								onClick={() => updateWhetherEarliestDeliveryDateIsSpecifiedByUser(true)}
								checked={earliestDeliveryDateSpecifiedByUser}/>
							<label className="form-check-label" htmlFor="Destination-Earliest-Time-Required">
								Yes
							</label>
						</div>
						<div className="form-check form-check-inline my-1">
							<input type="radio" className="form-check-input"
								id="Destination-Earliest-Time-Not-Required"
								onClick={() => updateWhetherEarliestDeliveryDateIsSpecifiedByUser(false)}
								checked={!earliestDeliveryDateSpecifiedByUser}/>
							<label className="form-check-label" htmlFor="Destination-Earliest-Time-Not-Required">
								No
							</label>
						</div>
					</div>
					<div className="form-group col-sm-12 col-md-6" style={{"zIndex":"10"}}>
						<label className="control-label">Earliest delivery date{!earliestDeliveryDateSpecifiedByUser && <span>(Now)</span>}</label>
						<DatePicker showTimeSelect name="freightPostingInputModel.earliestDeliveryDate" 
							disabled={!earliestDeliveryDateSpecifiedByUser} selected={earliestDeliveryDate} 
							onChange={date => updateEarliestDeliveryDate(date)}
							dateFormat="MM/dd/yyyy h:mm aa"/>
					</div>
					<input type="text" value={!earliestDeliveryDateSpecifiedByUser}  name="freightPostingInputModel.earliestDeliveryDateIsNow" hidden/>
					<div className="form-group col-sm-12 col-md-6" style={{"zIndex":"10"}}>
						<label className="control-label">Latest delivery date</label>
						<DatePicker showTimeSelect name="freightPostingInputModel.deliveryDeadline" 
							selected={latestDeliveryDate}
							onChange={date => updateLatestDeliveryDate(date)}
							dateFormat="MM/dd/yyyy h:mm aa"/>
					</div>
				</div>
			</div>
		</div>
	);
}

export { DestinationLocationCard };
